const intro = (
  <>
    <p>
      <strong>Sekcja "E-booki"</strong> na Remedium to zbiór profesjonalnych
      publikacji dla lekarzy, studentów medycyny i specjalistów ochrony zdrowia.
      Oferuje szybki i wygodny dostęp do materiałów edukacyjnych, poradników
      oraz aktualnych wytycznych medycznych. Każda publikacja została opracowana
      przez ekspertów i jest zgodna z najnowszymi standardami klinicznymi.
    </p>
    <p>
      Wszystkie e-booki dostępne na platformie można pobierać i czytać na
      różnych urządzeniach, co pozwala na naukę i rozwój zawodowy bez
      ograniczeń. Dzięki regularnym aktualizacjom użytkownicy mają pewność, że
      korzystają z najbardziej aktualnych i rzetelnych źródeł wiedzy.
    </p>
  </>
);

const content = (
  <>
    <h3>E-booki medyczne – dostęp do wiedzy zawsze pod ręką</h3>
    <p>
      Nowoczesna medycyna wymaga stałej aktualizacji informacji.{" "}
      <strong>E-booki na Remedium</strong> to praktyczne źródło wiedzy w formie
      cyfrowej, które umożliwia szybkie przyswajanie treści z różnych dziedzin.
      Publikacje obejmują szeroki zakres tematów – od diagnostyki i leczenia
      chorób przewlekłych po organizację pracy w systemie ochrony zdrowia.
    </p>

    <h3>Tematyka e-booków dostępnych na Remedium</h3>
    <p>
      Publikacje poruszają kluczowe zagadnienia związane z medycyną kliniczną,
      organizacją systemu ochrony zdrowia oraz rozwojem zawodowym lekarzy. Wśród
      nich znajdują się m.in.:
    </p>
    <ul>
      <li>
        <strong>medycyna rodzinna i POZ</strong> – kompleksowe materiały dla
        lekarzy podstawowej opieki zdrowotnej, w tym dotyczące opieki
        koordynowanej i organizacji pracy w przychodni;
      </li>
      <li>
        <strong>edukacja medyczna i rozwój kompetencji</strong> – kursy,
        materiały szkoleniowe i opracowania wspierające ciągłe kształcenie i
        zdobywanie nowych umiejętności.
      </li>
    </ul>
    <p>
      Każdy e-book został opracowany tak, aby w przystępny sposób przekazywać
      kluczowe informacje, które można od razu wykorzystać w praktyce
      klinicznej.
    </p>

    <h3>Dlaczego warto korzystać z e-booków na Remedium?</h3>
    <p>Dzięki intuicyjnej platformie użytkownicy mogą:</p>
    <ul>
      <li>natychmiast pobierać e-booki i czytać je na dowolnym urządzeniu,</li>
      <li>korzystać z publikacji przygotowanych przez ekspertów medycznych,</li>
      <li>
        mieć dostęp do aktualnych standardów diagnostycznych i terapeutycznych,
      </li>
      <li>
        poszerzać swoją wiedzę bez ograniczeń czasowych i lokalizacyjnych.
      </li>
    </ul>

    <h3>Podsumowanie</h3>
    <p>
      <strong>Sekcja "E-booki"</strong> na Remedium to wygodne i praktyczne
      źródło wiedzy dla lekarzy, studentów i specjalistów ochrony zdrowia.
      Publikacje obejmują kluczowe zagadnienia medyczne i pomagają w podnoszeniu
      kompetencji zawodowych. Dzięki cyfrowemu formatowi użytkownicy mogą szybko
      znaleźć potrzebne informacje i mieć pewność, że korzystają z rzetelnych,
      aktualnych i sprawdzonych treści.
    </p>
    <p>
      Dzięki tej platformie e-booki medyczne stają się dostępne w każdym miejscu
      i o każdej porze, umożliwiając wygodną naukę i rozwój zawodowy zgodnie z
      najnowszymi standardami w medycynie.
    </p>
  </>
);

export const ebookDescription = { intro, content };
